// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included 
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import util from '../../../../share/util/utils';
import error from '../../../../common/nodejs/errors';

/** 各フェーズ定義 */
const PHASE = {
  WAITING: 'waiting',
  JUDGE: 'judge',
  CONFIRM: 'confirm',
  EXECUTION: 'execution',
  FLRR_VALVE_CHECK: 'flrr_valve_check',
  FRRL_VALVE_CHECK: 'frrl_valve_check',
  END: 'end',
  RE_EXECUTE: 're_execute',
  ERROR_SPEED: 'error_speed',
  ERROR_START: 'error_start',
  ERROR_END: 'error_end',
  FAILED: 'failed'
};

// 待ち時間
const WAIT_TIME = 1000;

export default {
  name: 'requirement109',
  data() {
    return {
      phase: PHASE.WAITING,
      isLoading: false,
      systemId: '',
      timer: null,
      isFirst: true,
      modal_work_support_109: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true }
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.ERROR_SPEED:
        case PHASE.ERROR_START:
        case PHASE.ERROR_END:
          return 'danger';
        case PHASE.END:
          return 'success';
        case PHASE.WAITING:
        case PHASE.FRRL_VALVE_CHECK:
        case PHASE.FLRR_VALVE_CHECK:
        case PHASE.CONFIRM:
        case PHASE.EXECUTION:
        case PHASE.RE_EXECUTE:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     * 初期化処理
     */
    init() {
      this.modal_work_support_109 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      // 待機処理
      this.startProcess();
    },

    /**
     * Wizardを閉じる
     */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_work_support_109 = false;
    },

    /**
     * exit処理(機能終了)
     * @param {*} intError 0:エラー遷移あり, 1:エラー遷移なし
     */
    async exit(intError) {
      try {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (intError === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * その他エラー発生時の表示
     */
    showUnexpectedError() {
      this.phase = PHASE.FAILED;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result handler.validate で返ってきたバリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /**
     * 待機遷移処理
     */
    async startProcess() {
      clearTimeout(this.timer);
      this.timer = null;
      this.phase = PHASE.WAITING;
      // 1000ms経過後確認遷移
      await util.sleep(WAIT_TIME);
      this.judgeProcess();
    },

    /**
     * センサ値判定遷移処理
     */
    async judgeProcess() {
      this.phase = PHASE.JUDGE;
      this.readProcess();
    },

    /**
     * 実行遷移処理
     */
    async executeProcess() {
      this.phase = PHASE.EXECUTION;
      await this.executeTransitionProcess();
    },

    /**
     * FL/RRバルブチェック遷移処理
     * @param time - 経過時間
     */
    async flRrValveCheckProcess(time) {
      this.isLoading = false;
      this.phase = PHASE.FLRR_VALVE_CHECK;
      // 指定時間経過後、FR/RLバルブチェックに遷移
      await util.sleep(time);
      await this.frRlValveCheckProcess();
    },

    /**
     * FR/RLバルブチェック遷移処理
     */
    async frRlValveCheckProcess() {
      this.phase = PHASE.FRRL_VALVE_CHECK;
      await this.executeCheckProcess();
    },

    /**
     * 終了遷移処理
     * @param time - 経過時間
     */
    async successProcess(time) {
      this.phase = PHASE.END;
      // 指定時間経過後、再実行に遷移
      await util.sleep(time.wait_time1);
      await this.retryProcess(time);
    },

    // 再実行遷移処理
    async retryProcess(time) {
      this.phase = PHASE.RE_EXECUTE;
      // 指定時間経過後、画面遷移がなければ終了処理
      this.timer = setTimeout(() => this.execTimeout(), time.wait_time2);
    },

    // 車輪速超過エラー遷移処理
    overSpeed() {
      this.phase = PHASE.ERROR_SPEED;
    },

    /**
     * 開始不可遷移処理
     * @param time - 経過時間
     */
    async unableToStartProcess(time) {
      this.phase = PHASE.ERROR_START;
      await util.sleep(time);
      this.exit(0);
    },

    /**
     * 終了不可遷移処理
     * @param time - 経過時間
     */
    async unableToEndProcess(time) {
      this.phase = PHASE.ERROR_END;
      await util.sleep(time);
      this.exit(0);
    },

    /** データ読出し処理 */
    async readProcess() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read',
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              switch (response.data.user_data.result) {
                case 'ok':
                  // 確認表示に遷移
                  this.phase = PHASE.CONFIRM;
                  // タイマー処理の起動
                  this.timer = setTimeout(() => this.execTimeout(), response.data.user_data.wait_time);
                  break;
                case 'ng':
                  // 機能終了
                  this.closeWizard();
                  break;
                default:
                  break;
              }
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              this.showUnexpectedError();
              break;
            default:
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * SessionTransition処理
     */
    async sessionTransitionProcess() {
      try {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'session_transition'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // 正常コールバック
        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // セキュリティアクセス判定処理に遷移
              await this.secAccessProcess();
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (parseInt(response.data.async_code)) {
                case error.WSP_EXCESSIVE_WHEEL_SPEED_ERROR:
                  // 車輪速超過エラーに遷移
                  this.overSpeed();
                  break;
                default:
                  // 共通エラーに遷移
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** セキュリティアクセス判定処理 */
    async secAccessProcess() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'sec_access'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 実行(正常終了)に遷移
              await this.executeProcess();
              break;
            case config.STATUS_WSP_FAILED:
              // 共通エラーに遷移
              this.showUnexpectedError();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 実行処理
     */
    async executeTransitionProcess() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              await util.sleep(response.data.user_data.wait_time1);
              // FR/RLバルブチェックに遷移
              await this.flRrValveCheckProcess(response.data.user_data.wait_time2);
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              // 開始不可に遷移
              await this.unableToStartProcess(response.data.user_data.wait_time1);
              break;
            default:
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 実行監視処理
     */
    async executeCheckProcess() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_check'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 終了に遷移
              await this.successProcess(response.data.user_data);
              break;
            case config.STATUS_WSP_FAILED:
              // 終了不可に遷移
              await this.unableToEndProcess(response.data.user_data.wait_time1);
              break;
            default:
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** タイムアウト時処理 */
    async execTimeout() {
      this.isLoading = false;
      clearTimeout(this.timer);
      this.timer = null;
      await this.exit(0);
    },
  },
  /**
   * DOM作成後実行処理
   */
  mounted() {
    // 初期化
    this.init();
  }
};